import { forwardRef } from "react";
import classnames from "classnames";
import { InteractiveList } from "@circle-react-shared/InteractiveList";
import { OptionsDropdownItemContent } from "./OptionsDropdownItemContent";

interface OptionsDropdownProps {
  direction?: "up" | "down";
  items: any[];
  loading?: boolean;
  notFoundContent?: React.ReactNode | string;
  onSelect: (item: any) => void;
  styles: Record<string, unknown>;
}

export const OptionsDropdown = forwardRef<HTMLDivElement, OptionsDropdownProps>(
  (
    {
      items,
      onSelect,
      loading,
      notFoundContent,
      direction,
      ...rest
    }: OptionsDropdownProps,
    ref,
  ) => (
    <div
      ref={ref}
      className={classnames("select-list bg-primary", `direction-${direction}`)}
      {...rest}
    >
      <InteractiveList
        subsectionKey=""
        loading={loading || false}
        getKey={item => item.value}
        getItemContent={OptionsDropdownItemContent}
        items={items}
        onSelect={onSelect}
        notFoundContent={notFoundContent as string}
      />
    </div>
  ),
);

OptionsDropdown.displayName = "OptionsDropdown";
